import GlobalVariable from '../global/global-variable'

// 查询角色
const searchRolesApi = GlobalVariable.BASE_PATH + "/rest/role/search";

// 新增角色
const addRoleApi = GlobalVariable.BASE_PATH + "/rest/role/add";

// 新增角色
const updateRoleApi = GlobalVariable.BASE_PATH + "/rest/role/update";

// 删除角色
const deleteRoleApi = GlobalVariable.BASE_PATH + "/rest/role/delete";

export default {
    searchRolesApi,
    addRoleApi,
    updateRoleApi,
    deleteRoleApi
}



// WEBPACK FOOTER //
// ./src/request/api-role.js